module.exports = __webpack_public_path__ + "img/1552574259.2c832a99.jpg";